import { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useTitle } from 'react-use';

import { IDecisionPreview } from 'ApiPackage/SearchModule/interfaces/IDecisionPreview';
import { captchaSetIsActive } from 'CorePackage/CaptchaModule/actions/captchaActions';
import { getCaptchaToken } from 'CorePackage/CaptchaModule/selectors/captchaSelectors';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ROUTE_PORTAL } from 'CorePackage/MainModule/constants/routes';

import styles from '../styles.module.scss';
import { passportDecisionGetDataByQr, passportDecisionGetData } from '../../actions/passportKnmActions';
import { getPassportKnmDataDecision, getPassportKnmErrorStatus } from '../../reducers/passportKnmReducer';
import { DecisionHeader } from './DecisionHeader';
import { DecisionCommon } from './DecisionCommon';
import { DecisionControl } from './DecisionControl';
import { DecisionProsecutor } from './DecisionProsecutor';
import { DecisionFace } from './DecisionFace';

interface IPassportKnmStoreProps {
  captchaToken: string | null;
  passportData?: IDecisionPreview;
  errorStatus?: number;
}

const PassportDecisionWithoutStore = ({ passportData, errorStatus, captchaToken }: IPassportKnmStoreProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useTitle('Публичный паспорт проверки');
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const [activeTab, setActiveTab] = useState('common');
  const { id, token } = useParams<{ id: string; token: string }>();

  useEffect(() => {
    if (token && passportData && passportData.publishedStatus !== 'PUBLISHED') {
      history.push(`${ROUTE_PORTAL}?mt=decision`);
    }
  }, [passportData, token, history]);

  useEffect(() => {
    if (token) {
      dispatch(passportDecisionGetDataByQr(token));
    } else if (typeof captchaToken !== 'undefined') {
      if (!captchaToken) {
        dispatch(captchaSetIsActive(true));
      } else {
        dispatch(passportDecisionGetData(id));
      }
    }
  }, [id, token, captchaToken, dispatch]);

  if (errorStatus === 504) {
    return <div>Удаленный сервер не отвечает</div>;
  }
  if (errorStatus && errorStatus >= 500 && errorStatus <= 599) {
    return <div>Ошибка на сервере</div>;
  }

  return (
    <Layout>
      <div className={styles.Container}>
        {passportData && (
          <>
            <DecisionHeader activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className={styles.KnnWrapperContent}>
              {activeTab === 'common' && <DecisionCommon passportData={passportData} />}
              {activeTab === 'control' && <DecisionControl passportData={passportData} />}
              {activeTab === 'prosecutor' && <DecisionProsecutor passportData={passportData} />}
              {activeTab === 'face' && <DecisionFace passportData={passportData} />}
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

const mapStateToProps = (state: IRootState) => ({
  captchaToken: getCaptchaToken(state),
  passportData: getPassportKnmDataDecision(state),
  errorStatus: getPassportKnmErrorStatus(state),
});

export const PassportDecision = connect(mapStateToProps)(PassportDecisionWithoutStore);
